import { SALES_STATUS_LABEL, type Party, type SalesStatus } from "@cafegestor/shared";
import type { Ref } from "react";
import { EntityLookup, customerSource, salespersonSource } from "@/components/lookup";
import { Badge } from "@/components/ui";
import { SALES_TONE } from "./lib";

export function SalesStatusBadge({ status }: { status: SalesStatus }) {
  return <Badge tone={SALES_TONE[status]}>{SALES_STATUS_LABEL[status]}</Badge>;
}

/** Cliente por código, nome, nome fantasia ou CPF/CNPJ (digitação + lupa). */
export function CustomerPicker({
  value,
  label,
  onChange,
  disabled,
  id,
  inputRef,
  onSelected,
}: {
  value: string;
  label: string;
  onChange: (id: string, label: string, customer?: Party) => void;
  disabled?: boolean;
  id?: string;
  inputRef?: Ref<HTMLInputElement>;
  onSelected?: (customer: Party) => void;
}) {
  return (
    <EntityLookup
      source={customerSource}
      value={value}
      label={label}
      onChange={onChange}
      {...(disabled !== undefined ? { disabled } : {})}
      {...(id !== undefined ? { id } : {})}
      {...(inputRef !== undefined ? { inputRef } : {})}
      {...(onSelected !== undefined ? { onSelected } : {})}
    />
  );
}

/** Vendedor por código ou nome (digitação + lupa). */
export function SalespersonPicker({
  value,
  label,
  onChange,
  disabled,
  id,
}: {
  value: string;
  label: string;
  onChange: (id: string, label: string) => void;
  disabled?: boolean;
  id?: string;
}) {
  return (
    <EntityLookup
      source={salespersonSource}
      value={value}
      label={label}
      onChange={onChange}
      {...(disabled !== undefined ? { disabled } : {})}
      {...(id !== undefined ? { id } : {})}
    />
  );
}
